import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-email-sent-dialog',
  templateUrl: './email-sent-dialog.component.html',
  styleUrls: ['./email-sent-dialog.component.scss'],
  imports: [TranslatePipe],
})
export class EmailSentDialogComponent {
  activeModal = inject(NgbActiveModal);
}
